
import XButton from 'vux/src/components/x-button/index.vue'

export default {
data(){
return{
openid:''
}
},
components: {
XButton
},
mounted(){
this.openid = this.$route.query.openid;
}
}



// WEBPACK FOOTER //
// ./src/project/selfHelpFilingProject/filingNotice.vue